type Operation = 'request' | 'list' | 'load' | 'save';

export function apiErrorMessage(error: any, operation: Operation = 'request'): string {
    const status = typeof error?.status === 'number' ? error.status : undefined;
    const reason = error?.error?.reason;
    const keepEdits = operation === 'save' ? ' Your edits are still on screen.' : '';
    if (status === 401) {
        return 'Your session has expired. Sign in again to continue.' + keepEdits;
    }
    if (status === 403) {
        if (reason === 'ProvisionIdentityMissingException') {
            return 'Your account is missing the user ID needed to access provisions. Please contact support.' + keepEdits;
        }
        if (reason === 'ProvisionLibraryMismatchException') {
            return 'Use the provision library linked to your signed-in account.' + keepEdits;
        }
        if (reason === 'OASAccessDeniedException') {
            return (operation === 'save'
                ? 'Saving is not available for this library right now. Please contact support.'
                : 'Access to this provision library is currently unavailable. Please contact support.') + keepEdits;
        }
        return (operation === 'save'
            ? 'You do not have permission to save changes in this library. Ask your administrator for access.'
            : 'You do not have permission to use this feature. Ask your administrator for access.') + keepEdits;
    }
    if (status === 409 || status === 412) {
        return operation === 'save'
            ? 'This provision was updated after you opened it. Your edits are still on screen. Keep a copy of them, reopen the provision, and apply them again.'
            : 'This provision has changed. Please open it again.';
    }
    if (status === 404) {
        if (operation === 'request') {
            return 'The requested information is not available. Please try again later or contact support.';
        }
        if (operation === 'list') {
            return 'No provision library was found with that name. Check the library name and try again.';
        }
        return 'This provision could not be found. Refresh the list and choose it again.' + keepEdits;
    }
    if (status === 400 || status === 422) {
        if (operation === 'request') {
            return 'Some details could not be accepted. Check the selected values and part period, then try again.';
        }
        return (operation === 'save'
            ? 'Some changes could not be accepted. Check the part period and selected values, then try again.'
            : 'Check the provision library and name, then try again.') + keepEdits;
    }
    // A save may have succeeded even if no reply came back.
    if (operation === 'save') {
        return 'We could not confirm whether your changes were saved. Your edits are still on screen. Please try again later or contact support.';
    }
    if (status === 0) {
        return 'We could not reach the service. Check your connection and try again.';
    }
    if (status === 503 || status === 504) {
        return 'The service is temporarily unavailable. Please try again later.';
    }
    if (operation === 'list') {
        return 'We could not load the provisions for this library. Please try again later or contact support.';
    }
    if (operation === 'load') {
        return 'We could not load this provision. Please try again later or contact support.';
    }
    return 'We could not complete this request. Please try again later or contact support.';
}
